import React from 'react'
import { BANKING_BOTTOM_CONTENT, SOFTWARE_COURSE_PAGE_2, SOFTWARE_DETAILS_PAGE_2, SOFTWARE_HERO_PAGE_2 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { SOFTWARE_ACCORDIAN_2 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const SoftwarePage_2 = () => {
  return (
    <div className='outlet-render'>
        <CourseAsideHero  {...SOFTWARE_HERO_PAGE_2}/>
     <CoursesAside {...SOFTWARE_COURSE_PAGE_2}/>
     <CourseCard {...SOFTWARE_DETAILS_PAGE_2}/>
     <Accordian {...SOFTWARE_ACCORDIAN_2}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default SoftwarePage_2